var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLandingnative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 472,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "landing_native_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 356,
    height: 472
  }, /*#__PURE__*/React.createElement("rect", {
    width: 356,
    height: 472,
    rx: 20,
    fill: "#F4F8F3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#landing_native_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 356,
    height: 533,
    rx: 20,
    fill: "#F4F8F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.109 263.73c-11.382-19.521-7.015-60.612-7.015-60.612l-2.565 2.34c11.41-29.793 1.858-41.824 1.858-41.824-28.157-41.853-70.302-14.191-70.302-14.191s-30.916 4.928-19.478 41.838c.693 2.243.984 4.97 1.067 7.822-.097.333-4.866 17.832-6.571 21.114-1.234 2.381 4.963 5.662 8.554 7.323 8.013 34.93 9.815 33.698 9.815 33.698 14.155.679 25.426-1.633 34.548-5.731a1784.852 1784.852 0 012.551 13.636c3.036 24.049-30.957 39.527-30.957 39.527l64.521 24.353 64.119-40.856c.014 0-36.267-4.652-50.145-28.437z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.607 478.294l215.717-19.576 125.313 34.958.582 8.902-215.717 19.576-125.313-34.958-.582-8.902z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.243 479.111l211.35-12.391-32.33-132.382-206.58 9.636 27.56 135.137z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.185 343.669c.333 1.454-.402 2.852-1.636 3.129-1.234.277-2.509-.665-2.842-2.118-.332-1.454.402-2.852 1.636-3.129 1.248-.277 2.51.664 2.842 2.118z",
    fill: "#7AB778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.318 343.974l206.582-9.636-206.582 9.636L2.243 479.111l-5.837-.581-25.633-130.458 3.91-4.098z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.318 343.974l206.582-9.636-206.582 9.636zm0 0L2.243 479.111l-5.837-.581-25.633-130.458 3.91-4.098z",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.333 354.745l180.684-8.515 24.053 104.624-181.39 16.254-23.347-112.363z",
    fill: "#D1E3CD",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.607 478.294l125.326 34.958 215.704-19.576-125.313-34.958-215.717 19.576z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.459 498.508l-62.47-17.431 184.608-16.752 60.681 16.918-182.82 17.265z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.299 484.787l185.259-16.572",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.355 472.3l61.208 17.001M141.946 470.791l60.39 16.779M159.65 469.046l61.014 16.932M177.742 467.399l60.723 16.862M196.125 465.834l60.085 16.697",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.791 368.853l67.821-4.071a1.134 1.134 0 011.151.859l6.751 27.066a1.125 1.125 0 01-.998 1.398l-55.842 4.098c-.25.028-.486.125-.666.291l-8.554 9.871a1.129 1.129 0 01-1.871-.651l-8.859-37.519a1.134 1.134 0 011.067-1.342zM100.037 419.856l69.803-5.372 4.658 16.046-3.244.346-3.189.333-63.869 5.731-4.159-17.084zM87.546 436.83l-15.514-67.493-48.62 2.008-6.959 4.541 14.695 70.76 49.452-5.275 6.946-4.541z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.413 371.345l48.62-2.008 15.513 67.493-49.438 5.275-14.695-70.76z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.149 446.646l6.96-4.541",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.48 370.029l2.578 13.831c.07.36.54.457.748.152l2.205-3.253a.508.508 0 01.748-.097l3.023 2.547a.41.41 0 00.665-.401l-2.897-13.069-7.07.29z",
    fill: "#7AB778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.827 400.377l30.514-2.381M40.84 406.911l30.5-2.381M114.926 377.27l10.273-.734M115.259 381.783l38.139-1.979M115.869 386.546l38.139-1.98",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.103 381.839c.721 3.17-.887 6.244-3.59 6.853-2.704.623-5.49-1.454-6.211-4.624-.721-3.171.887-6.244 3.591-6.853 2.703-.609 5.49 1.453 6.21 4.624z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.84 425.588c.18.803-.222 1.578-.915 1.744-.693.153-1.386-.374-1.58-1.177-.181-.802.221-1.578.915-1.744.693-.152 1.4.374 1.58 1.177zM113.873 425.006c.18.803-.222 1.579-.915 1.745-.694.152-1.387-.374-1.581-1.177-.18-.803.222-1.578.915-1.744.693-.153 1.4.373 1.581 1.176zM118.905 424.439c.18.803-.222 1.578-.915 1.744-.693.152-1.386-.374-1.58-1.177-.181-.803.221-1.578.915-1.744.679-.152 1.386.374 1.58 1.177z",
    fill: "#7AB778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.147 303.866s-2.815-15.229-4.34 38.003c-1.414 49.827-1.968 102.118-1.968 102.118s-27.034.79-55.968 13.402l-18.729 7.767s48.619 26.886 83.223 37.629c31.872 9.886 34.853-14.412 31.054-73.445 0-.014-18.12-121.265-33.272-125.474z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.283 136.512s-40.621 21.639-17.371 43.361l27.602-27.551-10.231-15.81zM300.005 240.167s9.136-.236 14.598 12.114c0 0-5.989-14.025 4.465-25.627l-19.063 13.513z",
    fill: "#7AB778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.283 136.512s-49.687 48.595-19.908 34.971c62.219-28.45 59.031 43.237 59.031 43.237s8.567-7.794 5.406.36l16.207 25.087s34.645-13.084 36.489-56.653c.624-14.716-13.877-82.195-97.225-47.002z",
    fill: "#7AB778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.605 165.336c.929 7.435 0 37.132 13.143 39.305 13.142 2.174-2.26-37.283-2.26-37.283l-10.883-2.022z",
    fill: "#7AB778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.862 324.91c-15.736 70.621-23.014 143.582-23.014 143.582s-31.082-8.805-60.57-13.567l-32.219-8.639c-1.04-.471-12.214-5.621-15.832-9.193-3.799-3.766-5.892 6.59.083 11.311a58.868 58.868 0 014.34 3.779l-7.764 1.205a6.85 6.85 0 00-3.577 1.703c-5.407 4.901-23.041 21.154-19.7 22.165.831.249 1.76.263 2.772.111-6.03 4.97-6.502 10.162-4.824 10.328 2.523.263 5.712-1.551 8.886-4.112-2.786 3.226-6.252 10.342-2.384 10.162 5.185-.235 9.538-4.264 13.683-11.076 0 0-1.026 1.772-.568 1.357l-3.078 4.97s6.266 5.497 10.828 8.058c4.353 2.436 6.89-6.535.734-10.231 0 0 2.219-2.216 4.007-6.937 0 0 17.288 8.349 26.119 1.731l5.781.554c15.098 9.442 91.777 43.86 102.286 43.07 23.859-1.772 28.392-48.622 39.927-151.017.014.028-38.86-80.991-45.916-49.314z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.848 468.478s-7.431 3.946-8.928 14.911",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.143 428.966c12.297-2.035 32.15-8.819 32.164-8.888 0 0-7.611-95.791-31.817-124.159-1.234-2.644-5.296-8.113-18.286-10.023a179.766 179.766 0 01-11.271-2.049c-12.699-2.728-23.042-6.521-25.995-8.39 0 0 .014.11.042.29-.069-.041-.152-.083-.222-.124 0 0 .582 2.561-.333 5.551-.083.264-.166.527-.277.803a3.732 3.732 0 01-.152.347c-.194.429-.402.872-.666 1.301-3.965 6.535-30.264 9.165-56.549-4.707 0 0-45.154 25.571-57.188 34.445-18.466 39.291-26.396 128.022-26.396 123.896 0-1.122 37.626 18.565 62.081 19.632.139 6.963-5.989 94.918-5.989 94.918s106.334 5.427 153.442-19.604c0 0-18.563-61.761-16.386-78.997.305-2.049 3.271-19.216 3.798-24.242z",
    fill: "#D1E3CD",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.636 135.944s-52.072-12.128-48.8 1.26c3.286 13.388 16.747 25.073 16.747 25.073s-15.347-.388-7.292 7.393 14.792 7.199 14.792 7.199l24.553-40.925z",
    fill: "#7AB778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.02 255.52s5.351-1.343 15.181-9.871",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.628 192.527s-3.619-67.008-38.888-58.784",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.636 211.818c.803-12.437-8.395-23.153-20.544-23.934-12.148-.782-22.647 8.666-23.45 21.103-.802 12.438 8.396 23.154 20.544 23.935 12.149.782 22.648-8.667 23.45-21.104z",
    fill: "#D1E3CD",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.519 211.024c-.583 8.929-7.736 15.741-15.999 15.215-8.263-.526-14.487-8.21-13.919-17.14.582-8.929 7.736-15.741 15.999-15.215 8.262.54 14.501 8.21 13.919 17.14z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.259 203.921c.014 1.8 1.151 3.254 2.537 3.24 1.387-.014 2.496-1.481 2.482-3.281-.014-1.8-1.151-3.254-2.537-3.24-1.386 0-2.496 1.468-2.482 3.281zM241.515 194.452c-2.024-2.769-4.894-3.752-7.182-4.486-2.537-.817-5.032-1.634-6.1-.457-.637.706-.679 2.035-.124 2.866.762 1.177 2.481 1.121 4.089 1.288 6.225.65 9.788 4.374 10.495 3.461.388-.526-.638-1.925-1.178-2.672z",
    fill: "#7AB778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.717 236.29s6.834-.277 11.285-4.832M203.806 126.225c.457-.055 20.975-5.634 36.516 11.893M326.859 138.852l-1.581 15.976s4.118-7.919 12.284-2.575",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.254 156.171s-17.398 24.547-8.526 24.505c13.406-.069 26.66-17.472 24.234-18.372-2.426-.913-15.708-6.133-15.708-6.133z",
    fill: "#7AB778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.457 483.583l6.807-14.426 7.39-5.842",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.457 483.583l6.807-14.426 7.39-5.842M63.381 477.353l7.903-8.93",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.621 465.1l-8.817 6.244-4.63 12.696",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.621 465.1l-8.817 6.244-4.63 12.696",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.621 313.363s56.148-13.872 54.9 57.151l-2.579 85.144s-10.481 2.16-21.377.886",
    stroke: "#7AB778",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.65 452.17l9.621-1.385",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.862 261.183a3.406 3.406 0 01-3.411 3.406 3.406 3.406 0 110-6.812 3.406 3.406 0 013.411 3.406zM3.016 152.255a3.406 3.406 0 01-3.41 3.406 3.406 3.406 0 110-6.812 3.406 3.406 0 013.41 3.406zM156.683 155.756a3.406 3.406 0 01-3.41 3.406 3.406 3.406 0 110-6.812 3.406 3.406 0 013.41 3.406zM33.256 254.385a3.406 3.406 0 01-3.41 3.406 3.406 3.406 0 110-6.812 3.406 3.406 0 013.41 3.406zM123.341 220.715c4.368-.235 7.833-3.821 7.833-8.238 0-4.554-3.701-8.251-8.262-8.251a8.13 8.13 0 00-2.399.36c-1.4-5.759-6.585-10.051-12.796-10.051-6.155 0-11.299 4.209-12.754 9.899a7.824 7.824 0 00-1.816-.208c-4.562 0-8.263 3.697-8.263 8.251 0 4.334 3.355 7.892 7.611 8.224l30.846.014zM165.861 78.06c4.547-.236 8.166-3.987 8.166-8.598 0-4.762-3.868-8.611-8.637-8.611-.874 0-1.706.125-2.496.374-1.469-6.023-6.876-10.494-13.35-10.494-6.419 0-11.798 4.402-13.323 10.341a8.595 8.595 0 00-1.9-.221c-4.769 0-8.637 3.863-8.637 8.611 0 4.528 3.508 8.238 7.944 8.584l32.233.014z",
    fill: "#fff",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.109 49v3.904M291.631 55.867l3.383 1.952M291.354 70.1l3.383-1.953M303.554 77.45v-3.904M316.031 70.584l-3.396-1.952M316.309 56.352l-3.397 1.952M71.353 109.238v3.918M58.876 116.119l3.383 1.952M58.599 130.337l3.382-1.952M70.799 137.703v-3.905M83.276 130.822l-3.397-1.952M83.553 116.603l-3.397 1.952M99.496 273.671v3.918M87.019 280.551l3.383 1.953M86.728 294.77l3.396-1.952M98.928 302.135v-3.918M111.405 295.254l-3.383-1.952M111.682 281.036l-3.383 1.952",
    stroke: "#7AB778",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))));
}

export default SvgLandingnative;